// extracted by mini-css-extract-plugin
export default {"cart-item":"CartItem_cart-item__vMvTV","summary":"CartItem_summary__deoIl","price":"CartItem_price__ztK1v","amount":"CartItem_amount__Desx9","actions":"CartItem_actions__gwQib"};